// extracted by mini-css-extract-plugin
module.exports = {"commitCommentContainer":"style_commitCommentContainer__Xrr2H","commitLink":"style_commitLink__2jViY","commitComment":"style_commitComment__EK0WN"};